module.exports = __webpack_public_path__ + "img/canvasMenu7.8729e25f.svg";